import type { TextContentData, TextElement } from '@/components/canvas/document/publicTypes';
import { scaleTextDocumentFontSizes } from './textNormalize';
import { getTextLayoutFromElement } from './textStyles';

export function getReferenceTextFontSize(element: TextElement): number {
  return getTextLayoutFromElement(element).typography.fontSize;
}

export function scaleTextDocumentForResize(
  document: TextContentData['document'],
  scale: number,
  baseFontSize: number,
): TextContentData['document'] {
  return scaleTextDocumentFontSizes(document, scale, baseFontSize);
}
